import store from "../stores/store"
import router from "../router"

const process = () =>{
  store.dispatch('eclipseLogOut')
  router.push({path: '/'})
}

export default process